import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageDesigns,
  PageDesign,
  PageDesignEdit,
  PageDesignStock,
} from '../pages/designs';
import {
  PageSupplier,
  PageSuppliers,
} from '../pages/suppliers';
import {
  PageColor,
  PageColors,
} from '../pages/colors';
import {
  PagePalette,
  PagePalettes,
} from '../pages/palettes';
import {
  PageDeliveryTime,
  PageDeliveryTimes,
} from '../pages/deliveryTimes';
import {
  PageArScene,
  PageArScenes,
} from '../pages/arScenes';

const RouteDesigns = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect
          to={`${path}/items`}
        />
      </Route>
      <Route exact path={`${path}/items`}>
        <PageDesigns />
      </Route>
      <Route exact path={`${path}/items/:_id`}>
        <PageDesign />
      </Route>
      <Route exact path={`${path}/items/:_id/edit`}>
        <PageDesignEdit />
      </Route>
      <Route exact path={`${path}/items/:_id/:stockId`}>
        <PageDesignStock />
      </Route>
      <Route exact path={`${path}/tfy/suppliers`}>
        <PageSuppliers />
      </Route>
      <Route exact path={`${path}/tfy/suppliers/:_id`}>
        <PageSupplier />
      </Route>
      <Route exact path={`${path}/tfy/colors`}>
        <PageColors />
      </Route>
      <Route exact path={`${path}/tfy/colors/:_id`}>
        <PageColor />
      </Route>
      <Route exact path={`${path}/tfy/palettes`}>
        <PagePalettes />
      </Route>
      <Route exact path={`${path}/tfy/palettes/:_id`}>
        <PagePalette />
      </Route>
      <Route exact path={`${path}/tfy/delivery-time`}>
        <PageDeliveryTimes />
      </Route>
      <Route exact path={`${path}/tfy/delivery-time/:_id`}>
        <PageDeliveryTime />
      </Route>
      <Route exact path={`${path}/ar-scenes`}>
        <PageArScenes />
      </Route>
      <Route exact path={`${path}/ar-scenes/:_id`}>
        <PageArScene />
      </Route>
    </Switch>
  );
};

export default RouteDesigns;
